var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v("\n  Invoice marked as UNPAID for\n\n  "),_c('span',{staticClass:"mr-1"},[_c('invoice-object',{attrs:{"entity-id":_vm.invoiceId(),"invoice":_vm.$lodash.get(_vm.activity, 'detail.invoice'),"open-new":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }